import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PayoutInfo, PayoutRequest, Payout } from '../interfaces/payout';
import { environment } from '../environments/environment';
export interface AffiliateCommission {
  id: string;
  orderId: string;
  amountEarned: number;
  status: 'pending' | 'available' | 'paid' | 'cancelled';
  createdAt: string;
  paidAt: string | null;
  discountCode?: { id: number; code: string } | null;
}

export interface AffiliateCode {
  id: number;
  code: string;
  percentage: number;
  commission_type: 'percentage' | 'fixed' | null;
  commission_value: number | null;
  isActive: boolean;
  uses: number;
  maxUses: number;
  expirationDate: string;
}

@Injectable({
  providedIn: 'root'
})
export class PayoutService {

  constructor(private http: HttpClient) { }

  getPayoutInfo(): Observable<PayoutInfo> {
    return this.http.get<PayoutInfo>(environment.apiUrl + 'affiliate/payout-info');
  }

  submitPayoutRequest(): Observable<PayoutRequest> {
    return this.http.post<PayoutRequest>(environment.apiUrl + 'affiliate/payout-requests', {});
  }

  getPayoutHistory(): Observable<PayoutRequest[]> {
    return this.http.get<PayoutRequest[]>(environment.apiUrl + 'affiliate/payout-requests');
  }

  getMyCommissions(): Observable<AffiliateCommission[]> {
    return this.http.get<AffiliateCommission[]>(environment.apiUrl + 'affiliate/commissions');
  }

  getMyCodes(): Observable<AffiliateCode[]> {
    return this.http.get<AffiliateCode[]>(environment.apiUrl + 'affiliate/codes');
  }

  getMyPayouts(): Observable<Payout[]> {
    return this.http.get<Payout[]>(environment.apiUrl + 'affiliate/payouts');
  }
}
